import Route from 'cio/pods/base/overview/tests/test/route';

export default class TestRoute extends Route {
  redirect(model) {
    if (!model.actionModel.isSplitTest) {
      this.router.transitionTo('campaigns.campaign.overview.tests');
    }
  }
}
